import dayjs from '~/timeInit';

const DATE_ONLY_FORMATS = ['YYYY/MM/DD', 'YYYY-MM-DD', 'DD/MM/YYYY'];
const DATE_ONLY_PATTERN = /^(?:\d{4}[/-]\d{2}[/-]\d{2}|\d{2}\/\d{2}\/\d{4})$/;

export function formatDateOnlyConditionValue(value: string): string {
  const trimmedValue = value.trim();

  if (!DATE_ONLY_PATTERN.test(trimmedValue)) {
    return value;
  }

  const parsedValue = dayjs(trimmedValue, DATE_ONLY_FORMATS, true);

  return parsedValue.isValid() ? parsedValue.format('DD/MM/YYYY') : value;
}
